import {useDispatch, useSelector} from 'react-redux';
import {BrowserRouter as Router, Navigate, Route, Routes} from "react-router-dom";
import LayoutContainer from "./layouts/LayoutContainer";
import React, {useEffect} from "react";
import {login} from "./redux/slice/authSlice";
import "./resources/css/pretendard.css"
import "./resources/css/navHeader.css"
import "./resources/css/App.css"
import "./resources/css/qhd-size.css"
import "./resources/css/web-size.css"
import "./resources/css/mobile-size.css"
import "./resources/css/common.css"
import "./components/js-grid/simms-js-grid.css"
import "./resources/css/Pagination.css"
import "./resources/css/print.scss"
import "./resources/css/qrCode.css"
import AssetList from "./packages/asset/mng/info/AssetList";
import Login from "./packages/authentication/Authentication";
import StaticAssetForITM from "./packages/static/StaticAssetForITM";
import AssetCreate from "./packages/asset/mng/info/AssetCreate";
import Diligence from "./packages/asset/mng/diligence/Diligence";
import License from "./packages/asset/mng/license/License";
import LicenseCreate from "./packages/asset/mng/license/LicenseCreate";
import LicenseView from "./packages/asset/mng/license/LicenseView";
import Purchase from "./packages/asset/mng/purchase/Purchase";
import PurchaseCreate from "./packages/asset/mng/purchase/PurchaseCreate";
import PurchaseView from "./packages/asset/mng/purchase/PurchaseView";
import AssetView from "./packages/asset/mng/info/AssetView";
import AssetUpdate from "./packages/asset/mng/info/AssetUpdate";
import CompanyDepartmentManage from "./packages/settings/basicSettings/CompanyDepartmentManage";
import UserAccountGroupManage from "./packages/settings/basicSettings/UserAccountGroupManage";
import {
    CompanyCreateRedirect,
    CompanyDetailRedirect,
} from "./packages/settings/company/companyLegacyRedirects";
import {
    UserAccountCreateRedirect,
    UserAccountDetailRedirect,
    UserAccountInfoRedirect,
} from "./packages/settings/userAccount/userAccountLegacyRedirects";
import CustomCode from "./packages/settings/fieldMng/code/CustomCode";
import ServiceApplyList from "./packages/serviceRequest/serviceApply/ServiceApplyList";
import ServiceRequestList from "./packages/serviceRequest/serviceRequest/ServiceRequestList";
import GroupCodeManage from "./packages/settings/groupCode/GroupCodeManage";
import {HistoryList} from "./packages/settings/history/HistoryList";
import ServiceApplyCreate from "./packages/serviceRequest/serviceApply/ServiceApplyCreate";
import AssetHistoryList from "./packages/asset/history/AssetHistoryList";
import ServiceApplyView from "./packages/serviceRequest/serviceApply/ServiceApplyView";
import ServiceRequestCreate from "./packages/serviceRequest/serviceRequest/ServiceRequestCreate";
import ServiceRequestView from "./packages/serviceRequest/serviceRequest/ServiceRequestView";
import QrSimms from "./components/qrcode/QrSimms";
import AssetContractList from "./packages/asset/finance/contract/AssetContractList";
import {AssetContractCreate} from "./packages/asset/finance/contract/AssetContractCreate";
import {AssetContractTab} from "./packages/asset/finance/contract/AssetContractTab";
import DiligenceCreate from "./packages/asset/mng/diligence/DiligenceCreate";
import AssetLeaseList from "./packages/asset/finance/lease/AssetLeaseList";
import {AssetLeaseCreate} from "./packages/asset/finance/lease/AssetLeaseCreate";
import {AssetLeaseTab} from "./packages/asset/finance/lease/AssetLeaseTab";

import {Toaster} from "./shadCn/components/ui/sonner";
import AssetDepreciationList from "./packages/asset/finance/depreciation/AssetDepreciationList";
import {AssetDepreciationCreate} from "./packages/asset/finance/depreciation/AssetDepreciationCreate";
import {AssetDepreciationTab} from "./packages/asset/finance/depreciation/AssetDepreciationTab";
import {AssetEosList} from "./packages/asset/finance/eos/AssetEosList";
import DiligenceView from "./packages/asset/mng/diligence/subPages/DiligenceView";
import {InspectionList} from "./packages/maintenance/inspection/InspectionList";
import {InspectionCreate} from "./packages/maintenance/inspection/InspectionCreate";
import {InspectionHeaderCreate} from "./packages/maintenance/inspection/InspectionHeaderCreate";
import {InspectionTab} from "./packages/maintenance/inspection/InspectionTab";
import {AdminMenu} from "./components/menus/AdminMenu";
import Compare from "./packages/evaluation/sla/compare/Compare";
import {InspectionHeaderTab} from "./packages/maintenance/inspection/InspectionHeaderTab";
import {InspectionHeaderUpdate} from "./packages/maintenance/inspection/InspectionHeaderUpdate";
import {InspectionUpdate} from "./packages/maintenance/inspection/InspectionUpdate";
import {IncidentList} from "./packages/maintenance/incident/IncidentList";
import {IncidentTab} from "./packages/maintenance/incident/IncidentTab";
import {IncidentCreate} from "./packages/maintenance/incident/IncidentCreate";
import {IncidentUpdate} from "./packages/maintenance/incident/IncidentUpdate";
import {IncidentReportUpdate} from "./packages/maintenance/incident/report/IncidentReportUpdate";
import {WorkList} from "./packages/maintenance/work/WorkList";
import {WorkTab} from "./packages/maintenance/work/WorkTab";
import {WorkCreate} from "./packages/maintenance/work/WorkCreate";
import {WorkUpdate} from "./packages/maintenance/work/WorkUpdate";
import SimmsLicense from "./packages/settings/SimmsLicense";
import StaticAssetDivideByPlatForm from "./packages/static/StaticAssetDivideByPlatForm";
import ReportCodeManage from "./packages/settings/report/ReportCodeManage";
import RentalAsset from "./packages/lifecycle/rentalAsset/rentalAsset";
import RentalAssetCreate from "./packages/lifecycle/rentalAsset/rentalAssetCreate";
import {InspectionReportUpdate} from "./packages/maintenance/inspection/report/InspectionReportUpdate";
import NoticeList from "./packages/settings/notice/NoticeList";
import {NoticeCreate} from "./packages/settings/notice/NoticeCreate";
import {NoticeUpdate} from "./packages/settings/notice/NoticeUpdate";
import {NoticeInfo} from "./packages/settings/notice/subPages/NoticeInfo";
import BulletinboardList from "./packages/settings/bulletinboard/BulletinboardList";
import {BulletinboardCreate} from "./packages/settings/bulletinboard/BulletinboardCreate";
import {BulletinboardUpdate} from "./packages/settings/bulletinboard/BulletinboardUpdate";
import {BulletinboardInfo} from "./packages/settings/bulletinboard/subPages/BulletinboardInfo";
import RentalRequestAdmin from "./packages/lifecycle/rentalRequestAdmin/rentalRequestAdmin";
import RentalRequestUser from "./packages/lifecycle/rentalRequestUser/rentalRequestUser";
import RentalAssetView from "./packages/lifecycle/rentalAsset/rentalAssetView";
import {CompareCreate} from "./packages/evaluation/sla/compare/CompareCreate";
import {CompareUpdate} from "./packages/evaluation/sla/compare/CompareUpdate";
import {SlaReportList} from "./packages/evaluation/sla/report/SlaReportList";
import {SlaReportInfo} from "./packages/evaluation/sla/report/subPages/SlaReportInfo";
import {SlaReportUpdate} from "./packages/evaluation/sla/report/SlaReportUpdate";
import ErrorPage from "./components/Utils/ErrorPage";
import StaticAssetType from "./packages/static/StaticAssetType";
import StaticAssetMap from "./packages/static/StaticAssetMap";
import {EvaluationReportList} from "./packages/evaluation/report/EvaluationReportList";
import {EvaluationReportCreate} from "./packages/evaluation/report/EvaluationReportCreate";
import {EvaluationReportView} from "./packages/evaluation/report/EvaluationReportView";
import ServiceRequestHandlingOverview from "./packages/serviceRequest/overview/ServiceRequestHandlingOverview";
import AccessLog from "./packages/settings/accessLog/AccessLog";
import StaticMaintenanceType from "./packages/static/StaticMaintenanceType";
import Notifications from "./packages/settings/notification/Notifications";
import {DailyCheckReportList} from "./packages/evaluation/dailyCheck/DailyCheckReportList";
import {DailyCheckReportCreate} from "./packages/evaluation/dailyCheck/DailyCheckReportCreate";
import {DailyCheckReportView} from "./packages/evaluation/dailyCheck/DailyCheckReportView";
import {DailyCheckReportUpdate} from "./packages/evaluation/dailyCheck/DailyCheckReportUpdate";
import {decodeToken, getFistPage, getToken} from "./components/commonmethod/CommonMethod";
import ServiceRequestFeedbackOverview from "./packages/serviceRequest/overview/ServiceRequestFeedbackOverview";
import {InspectionHeaderList} from "./packages/maintenance/inspection/InspectionHeaderList";
import {IntroductionList} from "./packages/lifecycle/introduction/IntroductionList";
import {IntroductionTab} from "./packages/lifecycle/introduction/IntroductionTab";
import {IntroductionCreate} from "./packages/lifecycle/introduction/IntroductionCreate";
import {IntroductionUpdate} from "./packages/lifecycle/introduction/IntroductionUpdate";
import RentalRequestAdminView from "./packages/lifecycle/rentalRequestAdmin/RentalRequestAdminView";
import RentalRequestUserCreate from "./packages/lifecycle/rentalRequestUser/RentalRequestUserCreate";
import {DisposeList} from "./packages/lifecycle/dispose/DisposeList";
import {DisposeTab} from "./packages/lifecycle/dispose/DisposeTab";
import {DisposeCreate} from "./packages/lifecycle/dispose/DisposeCreate";
import {DisposeUpdate} from "./packages/lifecycle/dispose/DisposeUpdate";
import {DisposeAssetList} from "./packages/lifecycle/dispose/DisposeAssetList";
import RentalRequestUserView from "./packages/lifecycle/rentalRequestUser/RentalRequestUserView";
import SimmsSystemPasswordReset from "./packages/settings/SimmsSystemPasswordReset";
import SystemLogs from "./packages/settings/SystemLogs";
import DashBoard_Asset_ITM from "./packages/static/DashBoard_Asset_ITM";
import ErrorList from "./components/Utils/ErrorList";
import DashBoard_Total from "./packages/static/DashBoard_Total";
import DashBoard_SLA from "./packages/static/DashBoard_SLA";
import DashBoard_Service from "./packages/static/DashBoard_Service";
import Claim from "./packages/gov/standard/claim/Claim";
import ClaimCode from "./packages/settings/egov/claim/ClaimCode";
import ComputerRoomList from "./packages/settings/computerRoom/ComputerRoomList";
import {ComputerRoomInfo} from "./packages/settings/computerRoom/subPages/ComputerRoomInfo";
import Gate from "./layouts/Gate";

function App() {
    const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
    const platFrom = useSelector(state =>state.auth.platFrom)

    if(platFrom==='ITM') {
        document.title = "SIMMS-ITM V3";
    }else if(platFrom==='IAM'){
        document.title = "SIMMS-IAM V3";
    }else if(platFrom==='SRM'){
        document.title = "SIMMS-SRM V3";
    }
    const dispatch = useDispatch();
    let vh = 0;
    useEffect(() => {
        vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    }, []);
    useEffect(() => {
        const accessToken = getToken();
        if(accessToken) {
            const user = JSON.parse(decodeToken(accessToken));
            if (accessToken) {
                // Redux 스토어 업데이트
                dispatch(login(user));
            }
        }
    }, [dispatch]);


    const firstPage =getFistPage()
    const pages = {
        '': isLoggedIn?  <LayoutContainer /> : <Login />,
        "/error" : <ErrorList/>,
        "/static/total" : <DashBoard_Total/>,
        "/static/asset" : <StaticAssetDivideByPlatForm/>,
        "/static/service": <DashBoard_Service/>,
        "/static/sla" : <DashBoard_SLA/>,
        "/asset/:id/edit" : <AssetUpdate/>,
        "/asset/:id" : <AssetView/>,
        "/asset/list" : <AssetList/>,
        "/asset/create" : <AssetCreate/>,
        "/diligence" : <Diligence/>,
        "/diligence/:id" : <DiligenceView/>,
        "/diligence/:id/handle" : <DiligenceView/>,
        "/diligence/:id/report" : <DiligenceView/>,
        "/diligence/create" : <DiligenceCreate/>,
        "/asset/static" : <StaticAssetForITM/>,
        "/asset/static/:type" : <StaticAssetType/>,
        "/asset/indoorMapping" : <StaticAssetMap/>,
        "/maintenance/:table/static/:type" : <StaticMaintenanceType/>,
        "/asset/history" : <AssetHistoryList/>,
        "/asset/contract" : <AssetContractList/>,
        "/asset/contract/create" : <AssetContractCreate/>,
        "/asset/contract/:id" : <AssetContractTab/>,
        "/asset/lease" : <AssetLeaseList/>,
        "/asset/lease/create" : <AssetLeaseCreate/>,
        "/asset/lease/:id" : <AssetLeaseTab/>,
        "/asset/depreciation" : <AssetDepreciationList/>,
        "/asset/depreciation/create" : <AssetDepreciationCreate/>,
        "/asset/depreciation/:id" : <AssetDepreciationTab/>,
        "/license" : <License/>,
        "/license/create" : <LicenseCreate/>,
        "/license/:id" : <LicenseView/>,
        "/asset/purchase" : <Purchase/>,
        "/asset/purchase/create" : <PurchaseCreate/>,
        "/asset/purchase/:id" : <PurchaseView/>,
        "/asset/eos" : <AssetEosList/>,
        "/settings/usergroup/list" : <UserAccountGroupManage/>,
        "/settings/code/common" : <GroupCodeManage/>,
        "/settings/code/asset" : <CustomCode/>,
        "/settings/code/asset/group" : <CustomCode/>,
        "/settings/code/asset/task" : <CustomCode/>,
        "/settings/code/location" : <CustomCode/>,
        "/settings/code/sla-group" : <CustomCode/>,
        "/settings/code/memo" : <GroupCodeManage/>,
        "/settings/code/diligence" : <GroupCodeManage/>,
        "/settings/code/purchase" : <GroupCodeManage/>,
        "/settings/code/purchase2" : <GroupCodeManage/>,
        "/settings/company" : <CompanyDepartmentManage/>,
        "/settings/company/create" : <CompanyCreateRedirect/>,
        "/settings/company/:id" : <CompanyDetailRedirect/>,
        "/settings/custom/common-code" : <CustomCode/>,
        "/settings/custom/common-string" : <CustomCode/>,
        "/settings/custom/group-field" : <CustomCode/>,
        "/settings/custom/group-code" : <CustomCode/>,
        "/settings/userAccount/list" : <UserAccountGroupManage/>,
        "/settings/userAccount/create/:id?" : <UserAccountCreateRedirect/>,
        "/settings/userAccount/detail/:id?" : <UserAccountDetailRedirect/>,
        "/settings/userAccount/info/:id" : <UserAccountInfoRedirect/>,
        "/settings/custom/project" : <CustomCode/>,
        "/settings/department/list" : <CompanyDepartmentManage/>,
        "/settings/code/service/group" : <GroupCodeManage/>,
        "/settings/maintenance/inspection/code" : <GroupCodeManage/>,
        "/settings/maintenance/incident/code" : <GroupCodeManage/>,
        "/settings/maintenance/work/code" : <GroupCodeManage/>,
        "/settings/lifecycle/rental/code" : <GroupCodeManage/>,
        "/settings/lifecycle/introduction/code" : <GroupCodeManage/>,
        "/settings/lifecycle/dispose/code" : <GroupCodeManage/>,
        "/settings/report" : <ReportCodeManage/>,
        "/settings/report/inspectionReportCode" : <ReportCodeManage/>,
        "/settings/report/inspectionReportCode/create" : <ReportCodeManage/>,
        "/settings/report/inspectionReportCode/:id" : <ReportCodeManage/>,
        "/settings/report/inspectionReportCode/update/:id" : <ReportCodeManage/>,
        "/settings/report/dailyCheck" : <ReportCodeManage/>,
        "/settings/report/dailyCheck/create" : <ReportCodeManage/>,
        "/settings/report/dailyCheck/:id" : <ReportCodeManage/>,
        "/settings/report/dailyCheck/update/:id" : <ReportCodeManage/>,
        "/serviceRequest/serviceRequest" : <ServiceRequestList/>,
        "/serviceRequest/serviceRequest/create" : <ServiceRequestCreate/>,
        "/serviceRequest/serviceRequest/:id" : <ServiceRequestView/>,
        "/serviceRequest/serviceApply" : <ServiceApplyList/>,
        "/serviceRequest/serviceApply/create" : <ServiceApplyCreate/>,
        "/serviceRequest/serviceApply/:id" : <ServiceApplyView/>,
        "/serviceRequest/handlingOverview" : <ServiceRequestHandlingOverview/>,
        "/serviceRequest/feedbackOverview" : <ServiceRequestFeedbackOverview/>,
        "/maintenance/inspection" : <InspectionList/>,
        "/maintenance/inspection/:id" : <InspectionTab/>,
        "/maintenance/inspection/create" : <InspectionCreate/>,
        "/maintenance/inspection/update/:id" : <InspectionUpdate/>,
        "/maintenance/inspection_header" : <InspectionHeaderList/>,
        "/maintenance/inspection_header/create" : <InspectionHeaderCreate/>,
        "/maintenance/inspection_header/:id" : <InspectionHeaderTab/>,
        "/maintenance/inspection_header/update/:id" : <InspectionHeaderUpdate/>,
        "/maintenance/inspection/report/update/:id" : <InspectionReportUpdate/>,
        "/maintenance/incident" : <IncidentList/>,
        "/maintenance/incident/:id" : <IncidentTab/>,
        "/maintenance/incident/create" : <IncidentCreate/>,
        "/maintenance/incident/update/:id" : <IncidentUpdate/>,
        "/maintenance/incident/report/update/:id" : <IncidentReportUpdate/>,
        "/maintenance/work" : <WorkList/>,
        "/maintenance/work/:id" : <WorkTab/>,
        "/maintenance/work/create" : <WorkCreate/>,
        "/maintenance/work/update/:id" : <WorkUpdate/>,
        "/settings/history" : <HistoryList/>,
        "/adminmenu" : <AdminMenu/>,
        "/evaluation/slaCompare" : <Compare/>,
        "/evaluation/slaCompare/create/:month" : <CompareCreate/>,
        "/evaluation/slaCompare/update/:month" : <CompareUpdate/>,
        "/evaluation/slaCompare/report" : <SlaReportList/>,
        "/evaluation/slaCompare/report/:id" : <SlaReportInfo/>,
        "/evaluation/slaCompare/report/update/:id" : <SlaReportUpdate/>,
        "/evaluation/dailyCheck" : <DailyCheckReportList/>,
        "/evaluation/dailyCheck/create" : <DailyCheckReportCreate/>,
        "/evaluation/dailyCheck/:id" : <DailyCheckReportView/>,
        "/evaluation/dailyCheck/update/:id" : <DailyCheckReportUpdate/>,
        "/evaluation/report/:type" : <EvaluationReportList/>,
        "/evaluation/report/:type/:id" : <EvaluationReportView/>,
        "/evaluation/report/create/:type" : <EvaluationReportCreate/>,
        "/lifecycle/rentalAsset/list" : <RentalAsset/>,
        "/lifecycle/rentalAsset/:id" : <RentalAssetView/>,
        "/lifecycle/rentalAsset/create" : <RentalAssetCreate/>,
        "/lifecycle/rentalRequestAdmin/list" : <RentalRequestAdmin/>,
        "/lifecycle/rentalRequestAdmin/:id" : <RentalRequestAdminView/>,
        "/lifecycle/rentalRequestUser/list" : <RentalRequestUser/>,
        "/lifecycle/rentalRequestUser/create" : <RentalRequestUserCreate/>,
        "/lifecycle/rentalRequestUser/:id" : <RentalRequestUserView/>,
        "/lifecycle/introduction" : <IntroductionList/>,
        "/lifecycle/introduction/create" : <IntroductionCreate/>,
        "/lifecycle/introduction/update/:id" : <IntroductionUpdate/>,
        "/lifecycle/introduction/:id" : <IntroductionTab/>,
        "/lifecycle/dispose" : <DisposeList/>,
        "/lifecycle/dispose/create" : <DisposeCreate/>,
        "/lifecycle/dispose/update/:id" : <DisposeUpdate/>,
        "/lifecycle/dispose/:id" : <DisposeTab/>,
        "/lifecycle/dispose/asset-list" : <DisposeAssetList/>,
        "/settings/noticelist/:type" : <NoticeList/>,
        "/settings/notice/create/:type" : <NoticeCreate/>,
        "/settings/notice/:id" : <NoticeInfo/>,
        "/settings/notice/update/:id" : <NoticeUpdate/>,
        "/settings/bulletinboardlist/:type" : <BulletinboardList/>,
        "/settings/bulletinboard/create/:type" : <BulletinboardCreate/>,
        "/settings/bulletinboard/:id" : <BulletinboardInfo/>,
        "/settings/bulletinboard/update/:id" : <BulletinboardUpdate/>,
        "/settings/notifications" : <Notifications/>,
        "/settings/accessLog" : <AccessLog/>,
        "/settings/computerRoom" : <ComputerRoomList/>,
        "/settings/computerRoom/:id" : <ComputerRoomInfo/>,
        "/test" : <DashBoard_Asset_ITM/>,
        // "/test" : <DashBoard_Total/>,
        "/login" : isLoggedIn? <Navigate to='/' /> : <Login />,
        "/qrcode" : isLoggedIn? <QrSimms /> :  <Login />,
        "/qrscan/:id" : isLoggedIn? <AssetView /> :  <Login />,
        "/licenseKey" : <SimmsLicense />,
        "/resetPassword" : <SimmsSystemPasswordReset />,
        "/logs" : <SystemLogs />,

        // 범정부메뉴
        "/settings/gov/claim" : <ClaimCode />,
        "/standard/prevent/claim/list" : <Claim />,

        "*" : <ErrorPage resonse={{data: {title: "rwerwe", reason: "1122"}}} />,

    }


    return (
        <>
            <Router>
                <Gate>
                    <Routes>
                        <Route path="/"   element={pages['']} >
                            <Route index element={pages[firstPage.url]} />
                            <Route path="/error" element={ pages["/error"]}/>
                            <Route path="/static/total" element={ pages["/static/total"]}/>
                            <Route path="/static/asset" element={ pages["/static/asset"]}/>
                            <Route path="/static/service" element={ pages["/static/service"]}/>
                            <Route path="/static/sla" element={pages["/static/sla"]}/>
                            <Route path="/asset/:id/edit" element={pages["/asset/:id/edit"]}/>
                            <Route path="/asset/:id" element={pages["/asset/:id"]}/>
                            <Route path="/asset/list" element={pages["/asset/list"]}/>
                            <Route path="/asset/create" element={pages["/asset/create"]}/>
                            <Route path="/diligence" element={pages["/diligence"]}/>
                            <Route path="/diligence/:id" element={pages["/diligence/:id"]}/>
                            <Route path="/diligence/:id/handle" element={pages["/diligence/:id/handle"]}/>
                            <Route path="/diligence/:id/report" element={pages["/diligence/:id/report"]}/>
                            <Route path="/diligence/create" element={pages["/diligence/create"]}/>
                            <Route path="/asset/static" element={pages["/asset/static"]}/>

                            {/*자산현황 그룹별, 업무별, 위치별*/}
                            <Route path="/asset/static/:type" element={pages["/asset/static/:type"]}/>
                            <Route path="/asset/indoorMapping" element={pages["/asset/indoorMapping"]}/>

                            <Route path="/maintenance/:table/static/:type" element={pages["/maintenance/:table/static/:type"]}/>

                            <Route path="/asset/history" element={pages["/asset/history"]}/>
                            <Route path="/asset/contract" element={pages["/asset/contract"]}/>
                            <Route path="/asset/contract/create" element={pages["/asset/contract/create"]}/>
                            <Route path="/asset/contract/:id" element={pages["/asset/contract/:id"]}/>
                            <Route path="/asset/lease" element={pages["/asset/lease"]}/>
                            <Route path="/asset/lease/create" element={pages["/asset/lease/create"]}/>
                            <Route path="/asset/lease/:id" element={pages["/asset/lease/:id"]}/>
                            <Route path="/asset/depreciation" element={pages["/asset/depreciation"]}/>
                            <Route path="/asset/depreciation/create" element={pages["/asset/depreciation/create"]}/>
                            <Route path="/asset/depreciation/:id" element={pages["/asset/depreciation/:id"]}/>
                            <Route path="/license" element={pages["/license"]}/>
                            <Route path="/license/create" element={pages["/license/create"]}/>
                            <Route path="/license/:id" element={pages["/license/:id"]}/>
                            <Route path="/asset/purchase" element={pages["/asset/purchase"]}/>
                            <Route path="/asset/purchase/create" element={pages["/asset/purchase/create"]}/>
                            <Route path="/asset/purchase/:id" element={pages["/asset/purchase/:id"]}/>
                            <Route path="/asset/eos" element={pages["/asset/eos"]}/>
                            <Route path="/settings/usergroup/list" element={pages["/settings/usergroup/list"]}/>

                            <Route path="/settings/code/common" element={pages["/settings/code/common"]}/>
                            <Route path="/settings/code/asset" element={pages["/settings/code/asset"]}/>
                            <Route path="/settings/code/asset/group" element={pages["/settings/code/asset/group"]}/>
                            <Route path="/settings/code/asset/task" element={pages["/settings/code/asset/task"]}/>
                            <Route path="/settings/code/location" element={pages["/settings/code/location"]}/>
                            <Route path="/settings/code/sla-group" element={pages["/settings/code/sla-group"]}/>
                            <Route path="/settings/code/memo" element={pages["/settings/code/memo"]}/>
                            <Route path="/settings/code/diligence" element={pages["/settings/code/diligence"]}/>
                            <Route path="/settings/code/purchase" element={pages["/settings/code/purchase"]}/>
                            <Route path="/settings/code/purchase2" element={pages["/settings/code/purchase2"]}/>

                            <Route path="/settings/company" element={pages["/settings/company"]} />
                            <Route path="/settings/company/create" element={pages["/settings/company/create"]} />
                            <Route path="/settings/company/:id" element={pages["/settings/company/:id"]} />
                            <Route path="/settings/custom/common-code" element={pages["/settings/custom/common-code"]} />
                            <Route path="/settings/custom/common-string" element={pages["/settings/custom/common-string"]} />
                            <Route path="/settings/custom/group-field" element={pages["/settings/custom/group-field"]} />
                            <Route path="/settings/custom/group-code" element={pages["/settings/custom/group-code"]} />
                            <Route path="/settings/userAccount/list" element={pages["/settings/userAccount/list"]} />
                            <Route path="/settings/userAccount/create/:id?" element={pages["/settings/userAccount/create/:id?"]} />
                            <Route path="/settings/userAccount/detail/:id?" element={pages["/settings/userAccount/detail/:id?"]} />
                            <Route path="/settings/userAccount/info/:id" element={pages["/settings/userAccount/info/:id"]} />
                            <Route path="/settings/custom/project" element={pages["/settings/custom/project"]} />
                            <Route path="/settings/department/list" element={pages["/settings/department/list"]} />
                            <Route path="/settings/code/service/group" element={pages["/settings/code/service/group"]} />
                            <Route path="/settings/maintenance/inspection/code" element={pages["/settings/maintenance/inspection/code"]} />
                            <Route path="/settings/maintenance/incident/code" element={pages["/settings/maintenance/incident/code"]}/>
                            <Route path="/settings/maintenance/work/code" element={pages["/settings/maintenance/work/code"]}/>
                            <Route path="/settings/lifecycle/rental/code" element={pages["/settings/lifecycle/rental/code"]}/>
                            <Route path="/settings/lifecycle/introduction/code" element={pages["/settings/lifecycle/introduction/code"]}/>
                            <Route path="/settings/lifecycle/dispose/code" element={pages["/settings/lifecycle/dispose/code"]}/>

                            <Route path="/settings/report" element={pages["/settings/report"]}/>
                            <Route path="/settings/report/inspectionReportCode" element={pages["/settings/report/inspectionReportCode"]}/>
                            <Route path="/settings/report/inspectionReportCode/create" element={pages["/settings/report/inspectionReportCode/create"]}/>
                            <Route path="/settings/report/inspectionReportCode/:id" element={pages["/settings/report/inspectionReportCode/:id"]}/>
                            <Route path="/settings/report/inspectionReportCode/update/:id" element={pages["/settings/report/inspectionReportCode/update/:id"]}/>

                            <Route path="/settings/report/dailyCheck" element={pages["/settings/report/dailyCheck"]}/>
                            <Route path="/settings/report/dailyCheck/create" element={pages["/settings/report/dailyCheck/create"]}/>
                            <Route path="/settings/report/dailyCheck/:id" element={pages["/settings/report/dailyCheck/:id"]}/>
                            <Route path="/settings/report/dailyCheck/update/:id" element={pages["/settings/report/dailyCheck/update/:id"]}/>

                            <Route path="/serviceRequest/serviceRequest" element={pages["/serviceRequest/serviceRequest"]}/>
                            <Route path="/serviceRequest/serviceRequest/create" element={pages["/serviceRequest/serviceRequest/create"]}/>
                            <Route path="/serviceRequest/serviceRequest/:id" element={pages["/serviceRequest/serviceRequest/:id"]}/>
                            <Route path="/serviceRequest/serviceApply" element={pages["/serviceRequest/serviceApply"]}/>
                            <Route path="/serviceRequest/serviceApply/create" element={pages["/serviceRequest/serviceApply/create"]}/>
                            <Route path="/serviceRequest/serviceApply/:id" element={pages["/serviceRequest/serviceApply/:id"]}/>
                            <Route path="/serviceRequest/handlingOverview" element={pages["/serviceRequest/handlingOverview"]}/>
                            <Route path="/serviceRequest/feedbackOverview" element={pages["/serviceRequest/feedbackOverview"]}/>

                            <Route path="/maintenance/inspection" element={pages["/maintenance/inspection"]}/>
                            <Route path="/maintenance/inspection/:id" element={pages["/maintenance/inspection/:id"]}/>
                            <Route path="/maintenance/inspection/create" element={pages["/maintenance/inspection/create"]}/>
                            <Route path="/maintenance/inspection/update/:id" element={pages["/maintenance/inspection/update/:id"]}/>
                            <Route path="/maintenance/inspection_header" element={pages["/maintenance/inspection_header"]}/>
                            <Route path="/maintenance/inspection_header/create" element={pages["/maintenance/inspection_header/create"]}/>
                            <Route path="/maintenance/inspection_header/:id" element={pages["/maintenance/inspection_header/:id"]}/>
                            <Route path="/maintenance/inspection_header/update/:id" element={pages["/maintenance/inspection_header/update/:id"]}/>
                            <Route path="/maintenance/inspection/report/update/:id" element={pages["/maintenance/inspection/report/update/:id"]}/>

                            <Route path="/maintenance/incident" element={pages["/maintenance/incident"]}/>
                            <Route path="/maintenance/incident/:id" element={pages["/maintenance/incident/:id"]}/>
                            <Route path="/maintenance/incident/create" element={pages["/maintenance/incident/create"]}/>
                            <Route path="/maintenance/incident/update/:id" element={pages["/maintenance/incident/update/:id"]}/>
                            <Route path="/maintenance/incident/report/update/:id" element={pages["/maintenance/incident/report/update/:id"]}/>

                            <Route path="/maintenance/work" element={pages["/maintenance/work"]}/>
                            <Route path="/maintenance/work/:id" element={pages["/maintenance/work/:id"]}/>
                            <Route path="/maintenance/work/create" element={pages["/maintenance/work/create"]}/>
                            <Route path="/maintenance/work/update/:id" element={pages["/maintenance/work/update/:id"]}/>

                            <Route path="/settings/history" element={pages["/settings/history"]}/>
                            <Route path="/adminmenu" element={pages["/adminmenu"]}/>
                            <Route path="/evaluation/slaCompare" element={pages["/evaluation/slaCompare"]}/>
                            <Route path="/evaluation/slaCompare/create/:month" element={pages["/evaluation/slaCompare/create/:month"]}/>
                            <Route path="/evaluation/slaCompare/update/:month" element={pages["/evaluation/slaCompare/update/:month"]}/>

                            <Route path="/evaluation/slaCompare/report" element={pages["/evaluation/slaCompare/report"]}/>
                            <Route path="/evaluation/slaCompare/report/:id" element={pages["/evaluation/slaCompare/report/:id"]}/>
                            <Route path="/evaluation/slaCompare/report/update/:id" element={pages["/evaluation/slaCompare/report/update/:id"]}/>

                            <Route path="/evaluation/dailyCheck" element={pages["/evaluation/dailyCheck"]}/>
                            <Route path="/evaluation/dailyCheck/create" element={pages["/evaluation/dailyCheck/create"]}/>
                            <Route path="/evaluation/dailyCheck/:id" element={pages["/evaluation/dailyCheck/:id"]}/>
                            <Route path="/evaluation/dailyCheck/update/:id" element={pages["/evaluation/dailyCheck/update/:id"]}/>

                            <Route path="/evaluation/report/:type" element={pages["/evaluation/report/:type"]}/>
                            <Route path="/evaluation/report/:type/:id" element={pages["/evaluation/report/:type/:id"]}/>

                            <Route path="/evaluation/report/create/:type" element={pages["/evaluation/report/create/:type"]}/>

                            <Route path="/lifecycle/rentalAsset/list" element={pages["/lifecycle/rentalAsset/list"]}/>
                            <Route path="/lifecycle/rentalAsset/:id" element={pages["/lifecycle/rentalAsset/:id"]}/>
                            <Route path="/lifecycle/rentalAsset/create" element={pages["/lifecycle/rentalAsset/create"]}/>
                            <Route path="/lifecycle/rentalRequestAdmin/list" element={pages["/lifecycle/rentalRequestAdmin/list"]}/>
                            <Route path="/lifecycle/rentalRequestAdmin/:id" element={pages["/lifecycle/rentalRequestAdmin/:id"]}/>
                            <Route path="/lifecycle/rentalRequestUser/list" element={pages["/lifecycle/rentalRequestUser/list"]}/>
                            <Route path="/lifecycle/rentalRequestUser/create" element={pages["/lifecycle/rentalRequestUser/create"]}/>
                            <Route path="/lifecycle/rentalRequestUser/:id" element={pages["/lifecycle/rentalRequestUser/:id"]}/>
                            <Route path="/lifecycle/introduction" element={pages["/lifecycle/introduction"]}/>
                            <Route path="/lifecycle/introduction/create" element={pages["/lifecycle/introduction/create"]}/>
                            <Route path="/lifecycle/introduction/update/:id" element={pages["/lifecycle/introduction/update/:id"]}/>
                            <Route path="/lifecycle/introduction/:id" element={pages["/lifecycle/introduction/:id"]}/>
                            <Route path="/lifecycle/dispose" element={pages["/lifecycle/dispose"]}/>
                            <Route path="/lifecycle/dispose/create" element={pages["/lifecycle/dispose/create"]}/>
                            <Route path="/lifecycle/dispose/update/:id" element={pages["/lifecycle/dispose/update/:id"]}/>
                            <Route path="/lifecycle/dispose/:id" element={pages["/lifecycle/dispose/:id"]}/>
                            <Route path="/lifecycle/dispose/asset-list" element={pages["/lifecycle/dispose/asset-list"]}/>

                            {/* 알림관리 - 공지사항 */}
                            <Route path="/settings/noticelist" element={<Navigate to="/settings/noticelist/main" replace />} />
                            <Route path="/settings/notice" element={<Navigate to="/settings/noticelist/main" replace />} />
                            <Route path="/settings/noticelist/:type" element={pages["/settings/noticelist/:type"]}/>
                            <Route path="/settings/notice/create/:type" element={pages["/settings/notice/create/:type"]}/>
                            <Route path="/settings/notice/:id" element={pages["/settings/notice/:id"]}/>
                            <Route path="/settings/notice/update/:id" element={pages["/settings/notice/update/:id"]}/>
                            {/* 알림관리 - 자료실 */}
                            <Route path="/settings/bulletinboardlist/:type" element={pages["/settings/bulletinboardlist/:type"]}/>
                            <Route path="/settings/bulletinboard/create/:type" element={pages["/settings/bulletinboard/create/:type"]}/>
                            <Route path="/settings/bulletinboard/:id" element={pages["/settings/bulletinboard/:id"]}/>
                            <Route path="/settings/bulletinboard/update/:id" element={pages["/settings/bulletinboard/update/:id"]}/>
                            {/* 알림관리 - 요청발송내역 */}
                            <Route path="/settings/notifications" element={pages["/settings/notifications"]}/>

                            {/* 로그출력 페이지 */}
                            <Route path="/logs" element={pages["/logs"]}/>

                            {/*범정부 - 코드관리 */}

                            <Route path="/settings/gov/claim" element={pages["/settings/gov/claim"]}/>

                            {/*범정부 - 메뉴 */}
                            <Route path="/standard/prevent/claim/list" element={pages["/standard/prevent/claim/list"]}/>
                            <Route path="/standard/prevent/claim/:id" element={pages["/standard/prevent/claim/list"]}/>





                            <Route path="/settings/accessLog" element={pages["/settings/accessLog"]}/>
                            <Route path="/settings/computerRoom" element={pages["/settings/computerRoom"]}/>
                            <Route path="/settings/computerRoom/:id" element={pages["/settings/computerRoom/:id"]}/>

                            <Route path="/test" element={pages["/test"]}/>

                        </Route>
                        <Route path="/login" element={pages["/login"]}/>
                        <Route path="/qrcode" element={pages["/qrcode"]}/>
                        <Route path="/qrscan/:id" element={pages["/qrscan/:id"]}/>

                        <Route path="/licenseKey" element={pages["/licenseKey"]}/>
                        <Route path="/resetPassword" element={pages["/resetPassword"]}/>
                        <Route path="*" element={pages["*"]}/>
                    </Routes>
                </Gate>
            </Router>

    <Toaster />
    </>
    );
}

export default App;
